/**
 * Swallows the click the browser fires right after a drag gesture, so nothing under the pointer reacts to it (as d3
 * does in v11). The listener is dropped on the next tick if no click comes.
 */
export const suppressNextClick = (view: Window): void => {
  const swallow = (event: MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
  };
  view.addEventListener('click', swallow, { capture: true, once: true });
  view.setTimeout(() => view.removeEventListener('click', swallow, { capture: true }), 0);
};
